module.exports = __webpack_public_path__ + "img/head-title.3634512d.png";